export default __webpack_public_path__ + "static/media/checkbox-checked.38cc7ecf.svg";